import { useId } from 'react';

/**
 * Из макета карты лояльности (Figma 1780-3330). `crossed` — баланс скрыт:
 * поверх глаза диагональная черта. Под чертой глаз вырезан маской, а не
 * обведён цветом фона: фон карточки — градиент, ровного цвета под зазор нет.
 */
export const EyeIcon = ({
  className,
  crossed = false,
}: {
  className?: string;
  crossed?: boolean;
}) => {
  // useId даёт «:r0:» — двоеточия в url(#…) WebView понимает не везде.
  const maskId = `eye-cross-${useId().replace(/[^a-zA-Z0-9_-]/g, "")}`;

  return (
    <svg className={className} aria-hidden width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {crossed ? (
        <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <rect width="24" height="24" fill="white" />
          <path d="M4 4L20 20" stroke="black" strokeWidth="4.5" strokeLinecap="round" />
        </mask>
      ) : null}
      <g mask={crossed ? `url(#${maskId})` : undefined}>
        <path opacity="0.5" d="M2 12C2 13.6394 2.42496 14.1915 3.27489 15.2957C4.97196 17.5004 7.81811 20 12 20C16.1819 20 19.028 17.5004 20.7251 15.2957C21.575 14.1915 22 13.6394 22 12C22 10.3606 21.575 9.80853 20.7251 8.70433C19.028 6.49956 16.1819 4 12 4C7.81811 4 4.97196 6.49956 3.27489 8.70433C2.42496 9.80853 2 10.3606 2 12Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M8.25 12C8.25 9.92893 9.92893 8.25 12 8.25C14.0711 8.25 15.75 9.92893 15.75 12C15.75 14.0711 14.0711 15.75 12 15.75C9.92893 15.75 8.25 14.0711 8.25 12ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z" fill="white"/>
      </g>
      {crossed ? (
        <path d="M4 4L20 20" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
      ) : null}
    </svg>
  );
};
